/* global axios */
import ApiClient from '../ApiClient';

// Fontes de dados do cliente (Fase 6): CRUD das fontes PostgreSQL read-only + "Testar conexão" (member = fonte
// salva, collection = parâmetros ainda não salvos, para o modal validar antes de gravar) + CRUD das queries
// nomeadas de cada fonte.
class PolarisDataSource extends ApiClient {
  constructor() {
    super('captain/data_sources', { accountScoped: true });
  }

  create(data = {}) {
    return axios.post(this.url, { data_source: data });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, { data_source: data });
  }

  testConnection(dataSource) {
    return axios.post(`${this.url}/test_connection`, {
      data_source: dataSource,
    });
  }

  testSavedConnection(id) {
    return axios.post(`${this.url}/${id}/test_connection`);
  }

  getQueries(sourceId) {
    return axios.get(`${this.url}/${sourceId}/queries`);
  }

  createQuery(sourceId, dataQuery) {
    return axios.post(`${this.url}/${sourceId}/queries`, {
      data_query: dataQuery,
    });
  }

  updateQuery(sourceId, queryId, dataQuery) {
    return axios.put(`${this.url}/${sourceId}/queries/${queryId}`, {
      data_query: dataQuery,
    });
  }

  deleteQuery(sourceId, queryId) {
    return axios.delete(`${this.url}/${sourceId}/queries/${queryId}`);
  }
}

export default new PolarisDataSource();
